<template>
  <div class="gestione-utenti" v-if="!isFetching">
    <h3 style="float: left">{{ labels.gestione_utenti }}</h3>
    <b-button
      variant="success"
      style="float: right"
      @click="crea_nuovo_utente"
      >{{ labels.crea_nuovo_utente }}</b-button
    >
    <b-table responsive striped hover :items="utenti" :fields="colonne_utenti">
      <template v-slot:cell(codice)="data">
        <!-- `data.value` is the value after formatted by the Formatter -->
        <b-link v-on:click="modifica_utente(data)">{{ data.value }}</b-link>
      </template>
      <template v-slot:cell(ruolo)="data">
        <!-- `data.value` is the value after formatted by the Formatter -->
        <span v-if="data.value == 'A'">{{ labels.amministratore }}</span>
        <span v-else>{{ labels.utente_normale }}</span>
      </template>
      <template v-slot:cell(pulsanti)="data">
        <div style="text-align: right">
          <b-button
            style="margin-right: 5px"
            variant="success"
            size="sm"
            @click="elimina_utente(data)"
            :disabled="invio_in_corso"
            >{{ labels.elimina_utente }}</b-button
          >
          <b-button
            variant="success"
            size="sm"
            @click="modifica_utente(data)"
            >{{ labels.modifica_utente }}</b-button
          >
        </div>
      </template>
    </b-table>
    <!--
    <b-alert
      :show="dismissCountDown"
      dismissible
      fade
      variant="warning"
      @dismiss-count-down="countDownChanged"
    >{{ labels.eliminazione_effettuata }}</b-alert>
-->
  </div>
</template>

<script>
import store from "@/store/index";
import router from "@/router/index";
const axios = require("axios");

export default {
  name: "GestioneUtenti",
  data() {
    return {
      labels: {},
      labels_errori: {},
      size: "sm",
      utenti: [],
      colonne_utenti: [],
      isFetching: true,
      invio_in_corso: false,
    };
  },
  components: {},
  watch: {
    "$store.state.Lingua"(Lingua) {
      fn_CambiaLingua(Lingua, this);
    },
  },
  methods: {
    crea_nuovo_utente() {
      try {
        this.$router.push({ name: "ModificaUtente", params: { utente: "" } });
      } catch (error) {
        this.registraErrore(error, "GestioneUtenti-crea_nuovo_utente");
      }
    },
    modifica_utente(utente) {
      try {
        this.$router.push({
          name: "ModificaUtente",
          params: { utente: utente.item.codice },
        });
      } catch (error) {
        this.registraErrore(error, "GestioneUtenti-modifica_utente");
      }
    },
    elimina_utente(utente) {
      this.$bvModal
        .msgBoxConfirm(
          this.labels.confermi_eliminazione + ": " + utente.item.codice + " ?",
          {
            title: this.labels.conferma_eliminazione,
            size: "md",
            buttonSize: "sm",
            okVariant: "success",
            okTitle: "OK",
            cancelVariant: "warning",
            cancelTitle: "Annulla",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true,
          }
        )
        .then((value) => {
          if (value) {
            let me = this;

            let parametri = {
              utente_collegato: this.$store.state.Utente,
              password_utente_collegato: this.$store.state.Password,
              struttura_utente_collegato: this.$store.state.Struttura,
              utente: utente.item.codice,
            };

            let ServerURL = this.$store.state.ServerURL;
            let parametri_json = JSON.stringify(parametri);
            fn_CambiaCursore("wait", this);
            this.invio_in_corso = true;

            axios({
              method: "post",
              url: ServerURL + "CheckIn/EliminaUtente",
              data: parametri_json,
            })
              .then(function (response) {
                me.invio_in_corso = false;
                fn_CambiaCursore("default", me);
                if (response.data.errore == 0) {
                  me.$root.$children[0].$refs.ApplicationAlert.show(
                    me.labels.eliminazione_effettuata
                  );
                  me.utenti.splice(utente.index, 1);
                } else if (response.data.errore == -2) {
                  me.registraErrore(
                    response.data.esito,
                    "GestioneUtenti-elimina_utente"
                  );
                } else {
                  me.$bvModal.msgBoxOk(me.labels_errori[response.data.esito], {
                    title: me.labels_errori.si_e_verificato_un_errore,
                    bodyClass: "errore",
                  });
                }
              })
              .catch(function (error) {
                me.invio_in_corso = false;
                fn_CambiaCursore("default", me);
                me.registraErrore(error, "GestioneUtenti-elimina_utente");
              });
          }
        })
        .catch((error) => {
          this.invio_in_corso = false;
          this.registraErrore(error, "GestioneUtenti-elimina_utente");
        });
    },
  },
  beforeRouteEnter(to, from, next) {
    try {
      let UtenteAutenticato = store.state.UtenteAutenticato;
      let UtenteAmministratore = store.state.UtenteAmministratore;
      if (
        (to.meta.requiresAuth && !UtenteAutenticato) ||
        (to.meta.is_admin && !UtenteAmministratore)
      ) {
        router.push(
          "/amministrazione/permessiinsufficienti",
          null,
          function () {}
        );
      } else {
        next();
      }
    } catch (error) {
      router.push({ name: "Errore", params: { errore: error.stack } });
    }
  },
  created() {
    try {
      let me = this;

      fn_CambiaLingua(this.$store.state.Lingua, this);

      let ServerURL = this.$store.state.ServerURL;
      let Utente = this.$store.state.Utente;
      let Password = this.$store.state.Password;
      let Struttura = this.$store.state.Struttura;

      let parametri = {
        utente: Utente,
        password: Password,
        struttura: Struttura,
      };

      let parametri_json = JSON.stringify(parametri);

      fn_CambiaCursore("wait", this);

      axios({
        method: "post",
        url: ServerURL + "CheckIn/LeggiUtenti",
        data: parametri_json,
      })
        .then(function (response) {
          fn_CambiaCursore("default", me);
          me.utenti = response.data.oggetto;
          me.isFetching = false;
        })
        .catch(function (error) {
          fn_CambiaCursore("default", me);
          me.registraErrore(error, "GestioneUtenti-created");
        });
    } catch (error) {
      this.registraErrore(error, "GestioneUtenti-created");
    }
  },
};

function fn_CambiaLingua(lingua, vm) {
  try {
    let labels_italiano = {
      gestione_utenti: "Gestione utenti",
      crea_nuovo_utente: "Crea nuovo utente",
      elimina_utente: "Elimina",
      modifica_utente: "Modifica",
      codice: "Codice",
      descrizione: "Descrizione",
      ruolo: "Ruolo",
      amministratore: "Amministratore",
      utente_normale: "Utente normale",
      email: "Email",
      disabilitato: "Disabilitato",
      confermi_eliminazione: "Confermi l'eliminazione dell'utente",
      conferma_eliminazione: "Conferma eliminazione",
      eliminazione_effettuata: "Eliminazione effettuata",
    };
    let labels_inglese = {
      gestione_utenti: "Gestione utenti",
      crea_nuovo_utente: "Crea nuovo utente",
      elimina_utente: "Elimina",
      modifica_utente: "Modifica",
      codice: "Codice",
      descrizione: "Descrizione",
      ruolo: "Ruolo",
      amministratore: "Amministratore",
      utente_normale: "Utente normale",
      email: "Email",
      disabilitato: "Disabilitato",
      confermi_eliminazione: "Confermi l'eliminazione dell'utente",
      conferma_eliminazione: "Conferma eliminazione",
      eliminazione_effettuata: "Eliminazione effettuata",
    };
    let labels_tedesco = {
      gestione_utenti: "Gestione utenti",
      crea_nuovo_utente: "Crea nuovo utente",
      elimina_utente: "Elimina",
      modifica_utente: "Modifica",
      codice: "Codice",
      descrizione: "Descrizione",
      ruolo: "Ruolo",
      amministratore: "Amministratore",
      utente_normale: "Utente normale",
      email: "Email",
      disabilitato: "Disabilitato",
      confermi_eliminazione: "Confermi l'eliminazione dell'utente",
      conferma_eliminazione: "Conferma eliminazione",
      eliminazione_effettuata: "Eliminazione effettuata",
    };
    let labels_francese = {
      gestione_utenti: "Gestione utenti",
      crea_nuovo_utente: "Crea nuovo utente",
      elimina_utente: "Elimina",
      modifica_utente: "Modifica",
      codice: "Codice",
      descrizione: "Descrizione",
      ruolo: "Ruolo",
      amministratore: "Amministratore",
      utente_normale: "Utente normale",
      email: "Email",
      disabilitato: "Disabilitato",
      confermi_eliminazione: "Confermi l'eliminazione dell'utente",
      conferma_eliminazione: "Conferma eliminazione",
      eliminazione_effettuata: "Eliminazione effettuata",
    };

    let labels_errori_italiano = {
      ultimo_amministratore:
        "La struttura deve avere almeno un utente amministratore. Eliminazione non permessa",
      si_e_verificato_un_errore: "Si è verificato un errore",
    };
    let labels_errori_inglese = {
      ultimo_amministratore:
        "La struttura deve avere almeno un utente amministratore. Eliminazione non permessa",
      si_e_verificato_un_errore: "Si è verificato un errore",
    };
    let labels_errori_tedesco = {
      ultimo_amministratore:
        "La struttura deve avere almeno un utente amministratore. Eliminazione non permessa",
      si_e_verificato_un_errore: "Si è verificato un errore",
    };
    let labels_errori_francese = {
      ultimo_amministratore:
        "La struttura deve avere almeno un utente amministratore. Eliminazione non permessa",
      si_e_verificato_un_errore: "Si è verificato un errore",
    };

    switch (lingua) {
      case "IT":
        vm.labels = labels_italiano;
        vm.labels_errori = labels_errori_italiano;
        break;
      case "EN":
        vm.labels = labels_inglese;
        vm.labels_errori = labels_errori_inglese;
        break;
      case "DE":
        vm.labels = labels_tedesco;
        vm.labels_errori = labels_errori_tedesco;
        break;
      case "FR":
        vm.labels = labels_francese;
        vm.labels_errori = labels_errori_francese;
        break;
      default:
        vm.labels = labels_inglese;
        vm.labels_errori = labels_errori_inglese;
        break;
    }

    vm.colonne_utenti.splice(0);
    vm.colonne_utenti.push({ key: "codice", label: vm.labels.codice });
    vm.colonne_utenti.push({
      key: "descrizione",
      label: vm.labels.descrizione,
    });
    vm.colonne_utenti.push({ key: "ruolo", label: vm.labels.ruolo });
    vm.colonne_utenti.push({ key: "email", label: vm.labels.email });
    vm.colonne_utenti.push({
      key: "disabilitato",
      label: vm.labels.disabilitato,
    });
    vm.colonne_utenti.push({ key: "pulsanti", label: "" });
  } catch (error) {
    vm.registraErrore(error, "GestioneUtenti-fn_CambiaLingua");
  }
}
function fn_CambiaCursore(cursore, vm) {
  document.querySelector("body").style.cursor = cursore;

  if (cursore == "wait") {
    vm.invio_in_corso = true;
  } else {
    vm.invio_in_corso = false;
  }
}
</script>
<style scoped>
.gestione-utenti {
  border-style: solid;
  border-width: 1px;
  border-color: lightgray;
  border-radius: 4px;
  padding: 20px;
}
</style>
